import { BROADCAST_BACKGROUND_SCAN } from 'actions/Types';
import { BACKGROUND_ADD } from 'store/eventConstants';
import { mapSignedUrlsToSources } from 'actions/utils';
import { withCurrentParams } from 'actions/utils';

/**
 * updateBackgroundUploadStatus updates the signed url fetched using s3 proxy once upload is successful.
 * @param {string} background contains Background
 */
function updateBackgroundUploadStatus(background) {
  return withCurrentParams(
    (dispatch, { teamId, eventId, broadcastId }, _, socket) => {
      const action = {
        type: BROADCAST_BACKGROUND_SCAN,
        request: async apiClient => {
          const signedUrlsBackground = await mapSignedUrlsToSources(
            [background],
            apiClient,
            teamId,
            eventId,
            true
          );

          if (!signedUrlsBackground.length) {
            console.warn('No signed URLs were fetched');
            return [];
          }

          const updatedBackground = signedUrlsBackground.find(
            newBackground => newBackground._id === background._id
          );
          socket.emit(BACKGROUND_ADD, { broadcastId });
          return updatedBackground;
        }
      };

      dispatch(action);
    }
  );
}

export default updateBackgroundUploadStatus;
